<div class="participating-restaurants">
    <h3 class="title">{{restaurantData.title}}</h3>
    <div class="package-cards">
        <finder-package-card *ngFor="let restaurant of restaurantData.restaurants"
            class="package"
            [data]="restaurant"
        ></finder-package-card>
    </div>
</div>
